document.addEventListener('DOMContentLoaded', function () {
  let user_exist = false;
  const input = document.getElementById('verify_mNum');
  const sendOtpBtn = document.getElementById('send_otp_btn');
  const errorMsg = document.getElementById('text-danger');
  const loginMain = document.getElementById('login_main');
  const otpMain = document.getElementById('otp_main');
  const mobileNumberDigit = document.getElementById('mobile_number_digit');
  const verifyOtpBtn = document.getElementById('verify_otp');
  const incorrect_otp_text = document.getElementById('incorrect-otp-text');
  const otpInputs = document.querySelectorAll('.otp-input');

  let serverOtp = ''; // Store server OTP
  let serverResponse = {}; // Store full server response

  // Only allow numbers in the mobile number input
  input.addEventListener('input', function () {
    this.value = this.value.replace(/\D/g, '');
  });

  // Auto move to next input field when OTP is entered
  otpInputs.forEach((input, index) => {
    input.addEventListener('input', function () {
      if (this.value.length === 1 && index < otpInputs.length - 1) {
        otpInputs[index + 1].focus();
      }
    });
  });
function startResendTimer() {
  let countdown = 60;
  resendOtpBtn.disabled = true;

  // Create or select the timer span
  let timerSpan = document.querySelector('.otp-timer');
  if (!timerSpan) {
    timerSpan = document.createElement('p');
    timerSpan.className = 'otp-timer';
    document.querySelector('.mobile-number-text').after(timerSpan);
  }

  timerSpan.textContent = `${countdown} seconds`;

  const timer = setInterval(() => {
    countdown--;
    timerSpan.textContent = `${countdown} seconds`;

    if (countdown <= 0) {
      clearInterval(timer);
      resendOtpBtn.disabled = false;
      // resendOtpBtn.textContent = 'Resend OTP';
      timerSpan.remove(); // remove the timer after 60s
    }
  }, 1000);
}

  // Send OTP button click
  sendOtpBtn.addEventListener('click', function (e) {
    e.preventDefault();
    const phone_no = input.value;

    if (/^\d{10}$/.test(phone_no)) {
      errorMsg.style.display = 'none';
      localStorage.setItem('phone_no', phone_no);
      loginMain.style.display = 'none';
      otpMain.style.display = 'block';
      mobileNumberDigit.textContent = `+91 ${phone_no}`;
      startResendTimer(); // Start 60s timer
      // API Call to send OTP
      const form = new FormData();
      form.append("phone_no", phone_no);

      const settings = {
        url: "https://mobile.acharyavikulbansal.com/api/v1/login-with-otp",
        method: "POST",
        timeout: 0,
        processData: false,
        mimeType: "multipart/form-data",
        contentType: false,
        data: form
      };

      $.ajax(settings).done(function (response) {
        serverResponse = JSON.parse(response);
        console.log("serverResponse",serverResponse);
        serverOtp = serverResponse.OTP; // Store the OTP from the server
        // Verify OTP button click
    verifyOtpBtn.addEventListener('click', function (e) {
  e.preventDefault();

  let enteredOtp = '';
  otpInputs.forEach(input => {
    enteredOtp += input.value.trim();
  });

  incorrect_otp_text.style.display = 'none';

  const isValidOtpFormat = /^\d{6}$/.test(enteredOtp);
  if (!isValidOtpFormat) {
    incorrect_otp_text.style.display = 'block';
    incorrect_otp_text.innerText = 'Please enter a valid 6-digit OTP';
    incorrect_otp_text.style.color = 'red';
    return;
  }

  // -------------------------------
  // 🔥 API CALL : VERIFY OTP
  // -------------------------------
  const formData = new FormData();
  formData.append("otp_request_id", serverResponse.otp_request_id); 
  formData.append("otp", enteredOtp);

  fetch("https://mobile.acharyavikulbansal.com/api/v1/verify-otp", {
    method: "POST",
    body: formData
  })
    .then(res => res.json())
    .then(verifyresponse => {

      console.log("Verify OTP Response:", verifyresponse);

      // -----------------------------------------
      // 🔍 CHECK: OTP SUCCESS?
      // API SUCCESS CONDITION → verifyresponse.status == true
      // -----------------------------------------
      if (verifyresponse.status === 200) {

        // ---------------------------------
        // ✅ Save Edmingle ID if available
        // ---------------------------------
        if (serverResponse.edmingle_user_id) {
          sessionStorage.setItem("edmingle_user_id", serverResponse.edmingle_user_id);
          console.log("✅ Edmingle user saved:", serverResponse.edmingle_user_id);
        }

        // ---------------------------------
        // ✅ Save token in localStorage
        // ---------------------------------
        if (serverResponse.token) {
          localStorage.setItem("auth_token", serverResponse.token);
          console.log("✅ Token saved:", serverResponse.token);
        }

        // ---------------------------------
        // 🔁 Shopify user redirect logic
        // ---------------------------------
        if (serverResponse.shopify_user_exist === "yes") {
          sessionStorage.setItem('shopify_access_token', serverResponse.shopify_access_token);
          sessionStorage.setItem('customer_id', serverResponse.user_id);
          sessionStorage.setItem('is_logged_in', 'true');
          // window.location.href = '/';  // redirect to login success URL
           window.location.href = serverResponse.website_login_url;
        } else {
          window.location.href = "/account/register"; // redirect to Shopify register
        }

      } else {
        // ---------------------------------
        // ❌ OTP INCORRECT
        // ---------------------------------
        incorrect_otp_text.style.display = "block";
        incorrect_otp_text.innerText = "Incorrect OTP";
        incorrect_otp_text.style.color = "red";
      }
    })
    .catch(err => {
      console.error("OTP Verification Error:", err);
      incorrect_otp_text.style.display = "block";
      incorrect_otp_text.innerText = "Something went wrong. Please try again.";
    });
});
      });

    } else {
      errorMsg.style.display = 'block';
    }
  });

    



  // Resend OTP button click
  const resendOtpBtn = document.getElementById('resendotp_btn');
  resendOtpBtn.addEventListener('click', function (e) {
    e.preventDefault();
    const phone_no = localStorage.getItem('phone_no');  // Get the phone number from localStorage

    if (phone_no && /^\d{10}$/.test(phone_no)) {
      errorMsg.style.display = 'none';
      startResendTimer(); // Start 60s timer
      // API Call to resend OTP
      const form = new FormData();
      form.append("phone_no", phone_no);

      const settings = {
        url: "https://mobile.acharyavikulbansal.com/api/v1/login-with-otp",  // Same URL to resend OTP
        method: "POST",
        timeout: 0,
        processData: false,
        mimeType: "multipart/form-data",
        contentType: false,
        data: form
      };

      $.ajax(settings).done(function (response) {
        serverResponse = JSON.parse(response);
        serverOtp = serverResponse.OTP;  // Update OTP
      });
    } else {
      // console.log('Invalid phone number');
      errorMsg.style.display = 'block';
    }
  });
  

  function getQueryParam(param) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
  }

  const customerData = getQueryParam('customer_has');
 
  if (customerData) {
    try {
      const decoded = atob(customerData);
      const parts = decoded.split('|');

      if (parts.length >= 3) {
        const email = parts[0];
        const password = parts[2];
        console.log('urlParams',password);
        const emailInput = document.querySelector('input[name="customer[email]"]');
        const passwordInput = document.querySelector('input[name="customer[password]"]');
        const form = emailInput?.closest('form');
        if (emailInput) emailInput.value = email;
        if (passwordInput) passwordInput.value = password;
        passwordInput?.focus();
          form.submit();
      }
    } catch (e) {
      console.error('Failed to decode customer_has param', e);
    }
  }



  // Enter key press for mobile number input
  input.addEventListener('keypress', function (e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      sendOtpBtn.click();
    }
  });

  // Enter key press for OTP inputs
  otpInputs.forEach(input => {
    input.addEventListener('keypress', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        verifyOtpBtn.click();
      }
    });
  });
    otpInputs.forEach((input, index) => {
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Backspace') {
        if (input.value === '' && index > 0) {
          otpInputs[index - 1].focus();
          otpInputs[index - 1].value = '';
        }
      }
    });
  });
  
});


// document.addEventListener('DOMContentLoaded', function () {
//   let serverOtp = '';
//   let serverResponse = {};

//   const input = document.getElementById('verify_mNum');
//   const sendOtpBtn = document.getElementById('send_otp_btn');
//   const errorMsg = document.getElementById('text-danger');
//   const loginMain = document.getElementById('login_main');
//   const otpMain = document.getElementById('otp_main');
//   const mobileNumberDigit = document.getElementById('mobile_number_digit');
//   const verifyOtpBtn = document.getElementById('verify_otp');
//   const incorrectOtpText = document.getElementById('incorrect-otp-text');
//   const otpInputs = document.querySelectorAll('.otp-input');
//   const resendOtpBtn = document.getElementById('resendotp_btn');

//   input.addEventListener('input', function () {
//     this.value = this.value.replace(/\D/g, '');
//   });

//   otpInputs.forEach((input, index) => {
//     input.addEventListener('input', function () {
//       if (this.value.length === 1 && index < otpInputs.length - 1) {
//         otpInputs[index + 1].focus();
//       }
//     });
//     input.addEventListener('keydown', function (e) {
//       if (e.key === 'Backspace' && this.value === '' && index > 0) {
//         otpInputs[index - 1].focus();
//         otpInputs[index - 1].value = '';
//       }
//     });
//     input.addEventListener('keypress', function (e) {
//       if (e.key === 'Enter') {
//         e.preventDefault();
//         verifyOtpBtn.click();
//       }
//     });
//   });

//   input.addEventListener('keypress', function (e) {
//     if (e.key === 'Enter') {
//       e.preventDefault();
//       sendOtpBtn.click();
//     }
//   });

//   function startResendTimer() {
//     let countdown = 60;
//     resendOtpBtn.disabled = true;
//     let timerSpan = document.querySelector('.otp-timer');
//     if (!timerSpan) {
//       timerSpan = document.createElement('p');
//       timerSpan.className = 'otp-timer';
//       document.querySelector('.mobile-number-text').after(timerSpan);
//     }
//     timerSpan.textContent = `${countdown} seconds`;
//     const timer = setInterval(() => {
//       countdown--;
//       timerSpan.textContent = `${countdown} seconds`;
//       if (countdown <= 0) {
//         clearInterval(timer);
//         resendOtpBtn.disabled = false;
//         timerSpan.remove();
//       }
//     }, 1000);
//   }

//   function sendOtp(phone_no) {
//     const form = new FormData();
//     form.append("phone_no", phone_no);
//     const settings = {
//       url: "https://mobile.acharyavikulbansal.com/api/v1/login-with-otp-old",
//       method: "POST",
//       timeout: 0,
//       processData: false,
//       mimeType: "multipart/form-data",
//       contentType: false,
//       data: form
//     };

//     $.ajax(settings).done(function (response) {
//       try {
//         serverResponse = JSON.parse(response);
//         serverOtp = String(serverResponse.OTP).trim();
//         console.log('Received OTP:', serverOtp);
//       } catch (err) {
//         console.error('Error parsing OTP response:', err);
//       }
//     });
//   }

//   sendOtpBtn.addEventListener('click', function (e) {
//     e.preventDefault();
//     const phone_no = input.value.trim();
//     if (/^\d{10}$/.test(phone_no)) {
//       errorMsg.style.display = 'none';
//       localStorage.setItem('phone_no', phone_no);
//       loginMain.style.display = 'none';
//       otpMain.style.display = 'block';
//       mobileNumberDigit.textContent = `+91 ${phone_no}`;
//       startResendTimer();
//       sendOtp(phone_no);
//     } else {
//       errorMsg.style.display = 'block';
//     }
//   });

//   verifyOtpBtn.addEventListener('click', function (e) {
//     e.preventDefault();
//     let enteredOtp = '';
//     otpInputs.forEach(input => enteredOtp += input.value.trim());
//     enteredOtp = enteredOtp.trim();

//     incorrectOtpText.style.display = 'none';
//     console.log('Entered OTP:', enteredOtp);
//     console.log('Server OTP:', serverOtp);

//     if (!/^\d{6}$/.test(enteredOtp)) {
//       incorrectOtpText.textContent = 'Please enter a valid 6-digit OTP';
//       incorrectOtpText.style.color = 'red';
//       incorrectOtpText.style.display = 'block';
//       return;
//     }

//     if (enteredOtp === serverOtp) {
//       if (serverResponse.shopify_user_exist === 'yes') {
//         localStorage.setItem('shopify_access_token', serverResponse.shopify_access_token);
//         localStorage.setItem('customer_id', serverResponse.user_id);
//         sessionStorage.setItem('is_logged_in', 'true');
//         window.location.href = serverResponse.website_login_url;
//       } else {
//         window.location.href = '/account/register';
//       }
//     } else {
//       incorrectOtpText.textContent = 'Incorrect OTP';
//       incorrectOtpText.style.color = 'red';
//       incorrectOtpText.style.display = 'block';
//     }
//   });

//   resendOtpBtn.addEventListener('click', function (e) {
//     e.preventDefault();
//     const phone_no = localStorage.getItem('phone_no');
//     if (phone_no && /^\d{10}$/.test(phone_no)) {
//       errorMsg.style.display = 'none';
//       startResendTimer();
//       sendOtp(phone_no);
//     } else {
//       errorMsg.style.display = 'block';
//     }
//   });

//   const customerData = new URLSearchParams(window.location.search).get('customer_has');
//   if (customerData) {
//     try {
//       const decoded = atob(customerData);
//       const [email, , password] = decoded.split('|');
//       const emailInput = document.querySelector('input[name="customer[email]"]');
//       const passwordInput = document.querySelector('input[name="customer[password]"]');
//       const form = emailInput?.closest('form');
//       if (emailInput) emailInput.value = email;
//       if (passwordInput) passwordInput.value = password;
//       passwordInput?.focus();
//       form?.submit();
//     } catch (e) {
//       console.error('Failed to decode customer_has param', e);
//     }
//   }
// });



